import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';

export default function Search({
  value = '',
  onChangeFunction = (value) => {}
}) {
  const [currentValue, setCurrentValue] = React.useState(value);

  const handleChange = (e) => {
    const newValue = e.target.value;

    setCurrentValue(newValue);
    onChangeFunction(newValue);
  };

  return (
    <ThemeProvider theme={backYouTheme}>
      <FormControl>
          <OutlinedInput
            type="search"
            id="outlined-adornment-amount"
            startAdornment={
              <InputAdornment position="start">
                <i className="fa-regular fa-magnifying-glass"></i>
              </InputAdornment>
            }
            sx={{ minWidth: '150px', maxWidth: '300px' }}
            placeholder={'rechercher'.trad()}
            size="small"
            value={currentValue}
            onChange={handleChange}
          />
      </FormControl>
    </ThemeProvider>
  );
};